import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "./Button";
interface PremiumGlowButtonProps {
  checkout?: boolean;
  label?: string;
  onClick?: () => void;
}
export function PremiumGlowButton({
  checkout = false,
  label = "Quiero acceder ahora →",
  onClick
}: PremiumGlowButtonProps) {
  const shouldReduceMotion = Boolean(useReducedMotion());
  return <motion.div className="relative w-full rounded-full sm:w-fit" whileHover={shouldReduceMotion ? undefined : {
    scale: 1.02,
    y: -2
  }} whileTap={shouldReduceMotion ? undefined : {
    scale: 0.98,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-174" data-mp="2zsas0j5zyy1n">
      <motion.span aria-hidden="true" className="pointer-events-none absolute -inset-3 rounded-full bg-[#F2B84B]/25 blur-xl" animate={shouldReduceMotion ? {
      opacity: 0.38,
      scale: 1
    } : {
      opacity: [0.3, 0.62, 0.3],
      scale: [0.98, 1.04, 0.98]
    }} transition={shouldReduceMotion ? {
      duration: 0
    } : {
      duration: 3,
      ease: "easeInOut",
      repeat: Infinity
    }} data-id="element-175" data-mp="2m1e9xm9p5z8u" />
      <span aria-hidden="true" className="pointer-events-none absolute -inset-[5px] rounded-full border border-[#F2B84B]/35 shadow-[0_0_18px_rgba(242,184,75,0.18)]" data-id="element-176" data-mp="261l3udgwt9gt" />
      <Button type="button" size="lg" data-checkout={checkout ? "" : undefined} onClick={onClick} className="relative h-14 w-full rounded-full border border-[#F8D788]/70 bg-[#F2B84B] px-7 text-[15px] font-bold text-[#101010] shadow-[0_7px_18px_rgba(217,138,36,0.24),0_0_22px_rgba(242,184,75,0.28),inset_0_1px_0_rgba(255,255,255,0.38)] transition-[background-color,box-shadow] duration-[250ms] ease-out hover:bg-[#F6C667] hover:shadow-[0_11px_24px_rgba(217,138,36,0.32),0_0_34px_rgba(242,184,75,0.48),inset_0_1px_0_rgba(255,255,255,0.45)] focus-visible:ring-[#F2B84B]/60 sm:w-auto sm:min-w-[245px]" data-id="element-177" data-mp="1rac61h2ushsl">
        {label}
      </Button>
    </motion.div>;
}